import React, { useEffect, useState} from 'react';
import { getPermission } from '../../../Conexiones/Conexion';
import '../../../CSS/Materiales.css'
import moment from 'moment/moment';
import { useNavigate } from 'react-router';
import { BsFiletypePdf } from 'react-icons/bs';
import { jsPDF } from "jspdf";
import { calibriBold,calibriRegular } from "../../../Fonts/font";
import watermark from "../../../Img/watermark.png"
import { Button, CloseButton, Modal} from 'react-bootstrap';
import autoTable from 'jspdf-autotable'
import { PropagateLoader} from 'react-spinners';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { getApi } from '../../../Conexiones/Models';
import { errorMessage, warningToast } from '../../../Utils/AlertMessage';
import Loading from '../../../Utils/Loading';

function GastoMaterial() {
    const navigate = useNavigate();
    const [entradas,setEntradas]=useState([]);
    const [listEntrada,setListEntrada]=useState([]);
    const [nombreObra,setNombreObra] = useState ('');
    const [dueño,setDueño] = useState ('');
    const numObra=parseInt(sessionStorage.getItem("obra"));
    const [busqueda,setBusqueda] = useState ('');
    const [totalMat,setTotalMat] = useState ('');
    const [direccion,setDireccion] = useState('');
    const [fechaSelect, setFecha] = useState();
    const [typePdf, setTypePdf] = useState('');
    const usuario = JSON.parse(sessionStorage.getItem('user'));
    const idUsuario = usuario[0].idUsuario;
    const [isLoading,setIsLoading]=useState(false);

    var registros = []
    var inicio='';
    var fin='';
    var totalSemana='';

    //MODAL PDF
    const [showPdf, setShowPdf] = useState(false);
    const handleClosePdf = () => {
        setShowPdf(false);
        setFecha('');
        setTypePdf('');
        setFecha('');
        registros=[]
    }
    const handleShowPdf = () =>{
            setShowPdf(true);
    }  

    //MODAL DESCARGANDO
    const [showDescargar, setShowDescargar] = useState(false);
    const handleCloseDescarg = () => {
        setShowDescargar(false);
    }
    const handleShowDescarg = () =>{
        setShowDescargar(true);
    }

    useEffect (()=>{
        const getEntradas = async () =>{
            setIsLoading(true);
            const permiso = await getPermission(idUsuario,27);
            if(permiso){
                const obraId = parseInt(sessionStorage.getItem("obra"));
                const endpoint = 'gastosMat/obra/ini/'+obraId;
                const res = await getApi(endpoint);
                if(res.status === 1){
                    if(res.data.length !== undefined){
                        setEntradas(res.data[0].gastos);
                        setListEntrada(res.data[0].gastos);
                        setTotalMat(res.data[0].total);
                        setNombreObra(res.data[0].obra);
                        setDireccion(res.data[0].direccion);
                        setDueño(res.data[0].cliente);
                    }else{
                        errorMessage(res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }else{
                navigate('/inicio');
            }
            setIsLoading(false);
        }
        getEntradas();
    },[idUsuario,navigate])

    const buscar = e => {
        setBusqueda(e.target.value);
        filtrar(e.target.value)
    }

    const filtrar= (textoIngresado) =>{
        var resultadoBusqueda = listEntrada.filter((elemento)=> {
            if(elemento.nombreBod.toString().toLowerCase().includes(textoIngresado.toLowerCase()) 
            || elemento.fechaEntMat.toString().toLowerCase().includes(textoIngresado.toLowerCase())
            || elemento.nota.toString().toLowerCase().includes(textoIngresado.toLowerCase()) ){
                return elemento;
            }
            return resultadoBusqueda;
        });
        setEntradas(resultadoBusqueda);
    }

   
    const regresar = () => {
        navigate('/inicio/Proyectos/Lista-Obras/Administracion-Obras/');
    }
    function formato(numero){
        var num = Number.parseFloat(numero).toFixed(2)
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');
    }

    const getRegistros = async (fechaIngresada) =>{
        if(typePdf===''){
            warningToast('DEBE SELECCIONAR UNA OPCIÓN');
        }else{
            handleShowDescarg();
            if(typePdf==="semana"){
                if(fechaIngresada===undefined || fechaIngresada===''){
                    warningToast('DEBE INGRESAR UNA FECHA');
                }else{
                    handleClosePdf();
                    const endpoint = 'gastos-matSemana-pdf/'+numObra+'/'+fechaIngresada;
                    const res = await getApi(endpoint);
                    if(res.status === 1){
                        if(res.data.length !== undefined){
                            registros=res.data[0].lista
                            inicio=res.data[0].inicio
                            fin=res.data[0].fin
                            totalSemana=res.data[0].totalSemana
                        }else{
                            errorMessage(res.data.message);
                        }
                    }else if(res.status === 210){
                        navigate('/');
                    }else{
                        errorMessage(res.message);
                    }
                    if(registros.length===0){
                        warningToast('NO EXISTEN REGISTROS DE LA FECHA SELECCIONADA');
                    }else{
                        descargar(registros,inicio,fin,totalSemana)
                    }
                }  
            }else{
                handleClosePdf();
                //PDF GENERAL
                const endpoint = 'gastos-matGeneral-pdf/'+numObra;
                const res = await getApi(endpoint);
                if(res.status === 1){
                    if(res.data.length !== undefined){
                        registros=entradas;
                        totalSemana=res.data[0].totalSemana;
                    }else{
                        errorMessage(res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
                descargar(registros,inicio,fin,totalSemana);
            }
            handleCloseDescarg();
        } 
    }

    const tipoPdf = e => {
        setTypePdf(e.target.value);
    }
    const descargar = (lista,ini,fin,totalSemana) => {
        handleShowDescarg();
        switch (typePdf) {
            case 'semana':
                var date = moment( new Date());
                const fecha = date.tz('America/Mexico_City').format('DD/MM/YYYY')
                const fechaDescarga = moment(fin).format('DD-MM-YYYY')
                //const fecha2 = date.tz('America/Mexico_City').format('DDMMYY')
                //console.log(fecha)
                var doc = new jsPDF({format: 'letter',orientation:"portrait"});
                var company_logo = {
                    w: 30,
                    h: 20
                };

                var startY=0;
                //IMAGEN
                var imgData ="https://www.app-system.rosmocoin.com/rosmo-img/rosmo-logo-v2.png"
                doc.addImage(imgData,'JPEG',10,25,company_logo.w,company_logo.h);
                //console.log(doc.internal.pageSize.getHeight())
                var logo = new Image();
                logo.src = watermark;
                doc.addImage(logo, 'JPEG',32.945, 89.7,150,100);
                //TITULO
                doc.addFileToVFS("calibri-bold.ttf", calibriBold);
                doc.addFont('calibri-bold.ttf', 'calibri-bold', 'bold');
                doc.setFont("calibri-bold","bold");
                doc.setFontSize(18);
                doc.setTextColor("#002060")
                doc.text("CONTROL GASTOS DE MATERIAL", doc.internal.pageSize.getWidth() / 2, 15, null, 'center');
                //LINEA #1
                doc.setDrawColor("#1A2E4F", 0, 0); // draw red lines    
                doc.setLineWidth(2.5);    
                doc.line(10, 18, 205, 18); // vertical line    
                //console.log(doc.internal.pageSize.getWidth())
                //obra,ubicación,ciudad,estado (TIPO DE LETRA BOLD)
                doc.setFont("calibri-bold","bold");
                doc.setFontSize(10);
                doc.setTextColor("black")
                doc.text("OBRA:", 70, 28, null, 'right');
                doc.text("UBICACIÓN:", 70, 33, null, 'right');
                doc.text("CIUDAD:", 70, 38, null, 'right');
                doc.text("ESTADO:", 70, 43, null, 'right');
                doc.text("FECHA:", 150, 45, null, 'right');
                doc.text("SEMANA:", 150, 49, null, 'right');
                //TIPO DE LETRA REGULAR
                doc.addFileToVFS("calibri-regular.ttf", calibriRegular);
                doc.addFont('calibri-regular.ttf', 'calibri-regular', 'normal');
                doc.setFont("calibri-regular","normal");
                doc.setFontSize(10);
                doc.text(nombreObra.toUpperCase(), 75, 28, null, 'left');
                doc.text(direccion.toUpperCase(), 75, 33, null, 'left');
                doc.text("CHILPANCINGO", 75, 38, null, 'left');
                doc.text("GUERRERO", 75, 43, null, 'left');
                //FECHA DESCARGA
                doc.setFont("calibri-regular","normal");
                doc.text(fecha, 165, 45, null, 'center');
                //FECHA DEL REPORTE
                doc.setFont("calibri-regular","normal");
                doc.text(moment(ini).format("DD/MM/YYYY")+" - " + moment(fin).format("DD/MM/YYYY"), 175, 49, null, 'center');

                //LINEA #2
                doc.setDrawColor("#1A2E4F", 0, 0); // draw red lines    
                doc.setLineWidth(1.0);    
                doc.line(10, 53, 205, 53); // vertical line  
                    
                //TABLA
                var rows = lista;
                //console.log(rows)
                //const last = rows[rows.length-1];
                //const totalSemana=last.totalSemana;
                let datos = []
                rows.forEach((element) => {
                    datos.push([element.nombreMat.toUpperCase(),
                    moment(element.fechaEntMat).format("DD-MM-YYYY"),
                    element.nombreUnidad.toUpperCase(),element.cantEntMat,
                    '$ '+formato(element.precioUni),
                    '$ '+formato(element.total)])
                    
                });
                //console.log(datos)
                //TABLA
                autoTable(doc,
                    {head: [['CONCEPTO','FECHA', 'UNIDAD', 'CANTIDAD','PRECIO','SUBTOTAL']],
                    body:datos , tableWidth: 'wrap',
                    margin: {right:10, left:10 },
                    headStyles :{halign:'center',lineWidth:1,lineColor:"#1A2E4F"},
                    startY: 60,
                    theme:"plain",
                    columnStyles: {
                        0: {halign:"left",cellWidth: 40},
                        1: {halign:"center",cellWidth: 30},
                        2: {halign:"center",cellWidth: 30},
                        3: {halign:"center",cellWidth: 30},
                        4: {halign:"right",cellWidth: 30},
                        5: {halign:"right",cellWidth: 35},
                    }
                })
                startY=doc.lastAutoTable.finalY;
                //LINEA AL FINAL DE LA TABLA
                doc.setDrawColor("black", 0, 0); // draw red lines    
                doc.setLineWidth(1.0);    
                doc.line(10, startY, 205, startY); // vertical line  
                //TOTALES
                doc.setFont("calibri-bold","bold");
                doc.setFontSize(12);
                doc.setTextColor("black")
                doc.text("TOTAL", 160, startY+15); 
                doc.text("$ "+formato(totalSemana), 204, startY+15,"right");  
                //FOOTER
                /*doc.text("ROSMO",
                doc.internal.pageSize.getWidth() / 2 - (doc.getTextWidth('FOOTER') / 2),
                doc.internal.pageSize.getHeight() - 15,
                { baseline: 'top' });
                
                doc.setDrawColor("black", 0, 0); // draw red lines    
                doc.setLineWidth(1.0);    
                doc.line(10, startY, 205, startY); // vertical line */ 

                //var blob = doc.output("blob");
                //window.open(URL.createObjectURL(blob));
                doc.save('GASTOS MAT '+nombreObra+' '+fechaDescarga+'.pdf');
            break;
            case 'general':
                var dateGeneral = moment( new Date());
                const fechaGeneral = dateGeneral.tz('America/Mexico_City').format('DD/MM/YYYY')
                let docGeneral = new jsPDF({format: 'letter',orientation:"portrait", title: "Report"});
                var company_logoGeneral = {
                    w: 30,
                    h: 20
                };

                var startYGeneral=0;
                //IMAGEN
                var imgDataGeneral ="https://www.app-system.rosmocoin.com/rosmo-img/rosmo-logo-v2.png"
                docGeneral.addImage(imgDataGeneral,'JPEG',10,25,company_logoGeneral.w,company_logoGeneral.h);
                //TITULO
                docGeneral.addFileToVFS("calibri-bold.ttf", calibriBold);
                docGeneral.addFont('calibri-bold.ttf', 'calibri-bold', 'bold');
                docGeneral.setFont("calibri-bold","bold");
                docGeneral.setFontSize(18);
                docGeneral.setTextColor("#002060")
                docGeneral.text("CONTROL GASTOS DE MATERIAL", docGeneral.internal.pageSize.getWidth() / 2, 15, null, 'center');
                //LINEA #1
                docGeneral.setDrawColor("#1A2E4F", 0, 0); // draw red lines    
                docGeneral.setLineWidth(2.5);    
                docGeneral.line(10, 18, 205, 18); // vertical line    
                //obra,ubicación,ciudad,estado (TIPO DE LETRA BOLD)
                docGeneral.setFont("calibri-bold","bold");
                docGeneral.setFontSize(10);
                docGeneral.setTextColor("black")
                docGeneral.text("OBRA:", 70, 28, null, 'right');
                docGeneral.text("UBICACIÓN:", 70, 33, null, 'right');
                docGeneral.text("CIUDAD:", 70, 38, null, 'right');
                docGeneral.text("ESTADO:", 70, 43, null, 'right');
                docGeneral.text("FECHA:", 150, 45, null, 'right');
                //TIPO DE LETRA REGULAR
                docGeneral.addFileToVFS("calibri-regular.ttf", calibriRegular);
                docGeneral.addFont('calibri-regular.ttf', 'calibri-regular', 'normal');
                docGeneral.setFont("calibri-regular","normal");
                docGeneral.setFontSize(10);
                docGeneral.text(nombreObra.toUpperCase(), 75, 28, null, 'left');
                docGeneral.text(direccion.toUpperCase(), 75, 33, null, 'left');
                docGeneral.text("CHILPANCINGO", 75, 38, null, 'left');
                docGeneral.text("GUERRERO", 75, 43, null, 'left');
                //FECHA DESCARGA
                docGeneral.setFont("calibri-regular","normal");
                docGeneral.text(fechaGeneral, 165, 45, null, 'center');
                //LINEA #2
                docGeneral.setDrawColor("#1A2E4F", 0, 0); // draw red lines    
                docGeneral.setLineWidth(1.0);    
                docGeneral.line(10, 53, 205, 53); // vertical line             
                //TABLA
                var rowsGeneral = lista;
                let datosGeneral = []
                rowsGeneral.forEach((element) => {
                    datosGeneral.push([element.nota.toUpperCase(),element.nombreMat.toUpperCase(),
                    moment(element.fechaEntMat).format("DD-MM-YYYY"),
                    element.cantEntMat,element.nombreUnidad.toUpperCase(),
                    '$ '+formato(element.precioUni),
                    '$ '+formato(element.total), element.totalNota ? (formato(element.totalNota)):('')])
                    
                });
                //console.log(datosGeneral)
                //TABLA  67.58472222222223
                autoTable(docGeneral,
                    {head: [['NOTA','CONCEPTO', 'FECHA', 'CANTIDAD','UNIDAD','PRECIO','SUBTOTAL','T NOTA']],
                    body:datosGeneral , tableWidth: 'wrap',
                    margin: {right:10, left:10 },
                    headStyles :{halign:'center',lineWidth:1,lineColor:"#1A2E4F"},
                    startY: 60,
                    theme:"plain",
                    didDrawCell: (data) => {
                        if (data.section === 'body' && data.column.dataKey === 7 && data.cell.raw !== "NaN") {
                            //console.log(data)
                            //console.log(data.row.raw==="TOTAL NOTA:")
                            //console.log(data)
                        }
                    },
                    columnStyles: {
                        0: {halign:"center",cellWidth: 30},
                        1: {halign:"center",cellWidth: 25},
                        2: {halign:"center",cellWidth: 25},
                        3: {halign:"center",cellWidth: 25},
                        4: {halign:"center",cellWidth: 25},
                        5: {halign:"right",cellWidth: 25},
                        6: {halign:"right",cellWidth: 25}
                        }
                })
                startYGeneral=docGeneral.lastAutoTable.finalY;
                //LINEA AL FINAL DE LA TABLA
                docGeneral.setDrawColor("black", 0, 0); // draw red lines    
                docGeneral.setLineWidth(1.0);    
                docGeneral.line(10, startYGeneral, 205, startYGeneral); // vertical line  
                //TOTALES
                docGeneral.setFont("calibri-bold","bold");
                docGeneral.setFontSize(12);
                docGeneral.setTextColor("black")
                docGeneral.text("TOTAL", 160, startYGeneral+15); 
                docGeneral.text("$ "+formato(totalSemana), 204, startYGeneral+15,"right");  
                //FOOTER
                const pageCount = docGeneral.internal.getNumberOfPages();
                for(var i = 1; i <= pageCount; i++) {
                    //MARCA DE AGUA
                    var logoGeneral = new Image();
                    logoGeneral.src = watermark;
                    docGeneral.addImage(logoGeneral, 'JPEG',32.945, 89.7,150,100);
                    docGeneral.setPage(i);
                    docGeneral.text('Página ' + String(i) + ' de ' + String(pageCount),210-20,300-30,null,null,"right");
                }
                //var blobGeneral = docGeneral.output("blob",{filename:"reporte"});
                //window.open(URL.createObjectURL(blobGeneral));
                docGeneral.save('GASTOS MATERIALES GENERAL -'+nombreObra+'.pdf');
            break;
            default:
              console.log(`ERROR`);
        }
        handleCloseDescarg()
    }
    
    return (
        <div className="materiales">
            {
                isLoading === true ? 
                <Loading />:
                <div>
                    <div className='contabilidades-header'>
                        <div className='fab'><FaArrowLeftLong className='arrow' onClick={regresar} title='REGRESAR'/></div>
                        <label className="text-uppercase">CONTROL DE GASTOS DE MATERIAL</label>
                    </div>
                    <div className="row" >
                        <label className=' text-uppercase membretado'>{"NOMBRE DE LA OBRA : " + nombreObra }</label><br></br>
                        <label className='membretado'>{"DUEÑO : " + dueño}</label>
                    </div>
                    <div className='divboton' >                                                                                             
                        <div className='boton'  style={{display:'flex',justifyContent:"space-between",margin:"15px"}}>
                            <div>
                                <input value={busqueda} placeholder="Nota,fecha,bodega" onChange={buscar} type="search" className="form-control"  aria-describedby="basic-addon1"/>   
                            </div>
                            {//Restablecer
                                idUsuario === 185 ?
                                null :
                                    <button title='DESCARGAR' onClick={handleShowPdf}  style={{justifyContent:'center'}} className="btn btn-light btncolor" type="button">
                                    <BsFiletypePdf style={{fontSize:'25px'}}/> <label className="agregar">DESCARGAR</label>
                                </button>
                            }
                            {/* <button title='DESCARGAR' onClick={handleShowPdf}  style={{justifyContent:'center'}} className="btn btn-light btncolor" type="button">
                                <BsFiletypePdf style={{fontSize:'25px'}}/> <label className="agregar">DESCARGAR</label>
                            </button> */}
                            <div className='totalMat'>
                                <h5>{"TOTAL: $"+formato(totalMat?totalMat:'0.00')}</h5>
                            </div>
                        </div>
                    </div>
                    <div className="caja-asistencia" style={{marginTop:"10px"}} >
                        <div className="table tabla">
                            <table className="table text-uppercase">
                                <thead >
                                    {//Restablecer
                                        idUsuario === 185 ?
                                        <tr >
                                            <th>concepto</th>
                                            <th>cantidad</th>
                                            <th>unidad</th>
                                            <th>precio</th>
                                            <th>total</th>
                                            <th>total nota</th>
                                        </tr>:
                                        <tr >
                                            <th>nota</th>                           
                                            <th>codigo</th>
                                            <th>categoria</th>
                                            <th >fecha</th>
                                            <th>BODEGA</th>
                                            <th>concepto</th>
                                            <th>cantidad</th>
                                            <th>unidad</th>
                                            <th>precio</th>
                                            <th>total</th>
                                            <th>total nota</th>
                                        </tr>
                                    }
                                    {/* <tr >
                                        <th>nota</th>                           
                                        <th>codigo</th>
                                        <th>categoria</th>
                                        <th >fecha</th>
                                        <th>BODEGA</th>
                                        <th>concepto</th>
                                        <th>cantidad</th>
                                        <th>unidad</th>
                                        <th>precio</th>
                                        <th>total</th>
                                        <th>total nota</th>
                                    </tr> */}
                                </thead>
                                <tbody >
                                    {entradas.map(entrada =>{
                                        return(     
                                            entrada.totalNota ? ( 
                                                idUsuario === 185 ?
                                                <tr key={entrada.idEntMat} style={{borderTopWidth:'4px',borderTopColor:"black"}}> 
                                                    <td valign="middle">{entrada.nombreMat}</td>
                                                    <td valign="middle">{entrada.cantEntMat}</td>  
                                                    <td valign="middle">{entrada.nombreUnidad}</td>
                                                    <td valign="middle">${formato(entrada.precioUni)}</td>
                                                    <td valign="middle">${formato(entrada.total)}</td>
                                                    <td valign="middle">${formato(entrada.totalNota)}</td>
                                                </tr> :
                                                <tr key={entrada.idEntMat} style={{borderTopWidth:'4px',borderTopColor:"black"}}> 
                                                    <td valign="middle">{entrada.nota}</td>
                                                    <td valign="middle">{entrada.codigoMat}</td>
                                                    <td valign="middle">{entrada.nombreCatMat}</td>
                                                    <td valign="middle">{moment(entrada.fechaEntMat).format("DD-MM-YYYY")}</td>
                                                    <td valign="middle">{entrada.nombreBod}</td> 
                                                    <td valign="middle">{entrada.nombreMat}</td>
                                                    <td valign="middle">{entrada.cantEntMat}</td>  
                                                    <td valign="middle">{entrada.nombreUnidad}</td>
                                                    <td valign="middle">${formato(entrada.precioUni)}</td>
                                                    <td valign="middle">${formato(entrada.total)}</td>
                                                    <td valign="middle">${formato(entrada.totalNota)}</td>
                                                </tr>   
                                            ):(
                                                idUsuario === 185 ?
                                                <tr key={entrada.idEntMat}> 
                                                    <td valign="middle">{entrada.nombreMat}</td>
                                                    <td valign="middle">{entrada.cantEntMat}</td>  
                                                    <td valign="middle">{entrada.nombreUnidad}</td>
                                                    <td valign="middle">${formato(entrada.precioUni)}</td>
                                                    <td valign="middle">${formato(entrada.total)}</td>
                                                </tr> :
                                                <tr key={entrada.idEntMat}> 
                                                    <td valign="middle">{entrada.nota}</td>
                                                    <td valign="middle">{entrada.codigoMat}</td>
                                                    <td valign="middle">{entrada.nombreCatMat}</td>
                                                    <td valign="middle">{moment(entrada.fechaEntMat).format("DD-MM-YYYY")}</td>
                                                    <td valign="middle">{entrada.nombreBod}</td> 
                                                    <td valign="middle">{entrada.nombreMat}</td>
                                                    <td valign="middle">{entrada.cantEntMat}</td>  
                                                    <td valign="middle">{entrada.nombreUnidad}</td>
                                                    <td valign="middle">${formato(entrada.precioUni)}</td>
                                                    <td valign="middle">${formato(entrada.total)}</td>
                                                </tr> 
                                            )                                    
                                        )
                                    })}                        
                                </tbody>
                            </table>
                        </div>      
                    </div>

                    {/*PDF*/}
                    <Modal  show={showPdf}  onHide={handleClosePdf} >
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>DESCARGAR PDF</Modal.Title>
                            <CloseButton onClick={handleClosePdf} style={{backgroundColor:"white"}} />
                        </Modal.Header>
                        <Modal.Body  style={{textAlign:'left', marginTop:'15px'}}>
                            <div className="mb-3">
                                <div className="form-check">
                                    <input type="radio" className="form-check-input" onChange={tipoPdf} name="tipoPDF" value="general" id="medium" />
                                    <label className="form-check-label">GENERAL</label>
                                </div> 
                            </div>
                            <div className="mb-3">
                                <div className="form-check">
                                    <input type="radio" name="tipoPDF" className="form-check-input" onChange={tipoPdf} value="semana" id="regular" />
                                    <label className="form-check-label">SELECCIONE UNA FECHA</label>
                                </div> 
                                {
                                    typePdf==="semana"?(
                                        <div className="mb-3">
                                            <input type="date" className="form-control" onChange={(e)=>setFecha(e.target.value)}  id="exampleFormControlInput1" required/>
                                        </div>
                                    )
                                    :(null)
                                }
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button type="button" className="btn btn-secondary" onClick={handleClosePdf}>CANCELAR</Button> 
                            <Button type="button" className="btn btn-light btncolor" onClick={()=> getRegistros(fechaSelect)} >DESCARGAR</Button>                                                     
                        </Modal.Footer>
                    </Modal>

                    {/*DESCARGANDO....*/}
                    <Modal  show={showDescargar}  onHide={handleCloseDescarg} centered >
                        <Modal.Body  style={{textAlign:'center', marginTop:'15px',marginBottom:"5%"}}>
                            <div>
                                <h3>DESCARGANDO</h3>
                            </div>
                            <div style={{textAlign:'center', marginTop:'15px'}}>
                                <PropagateLoader color="#1A2E4F" />
                            </div>
                        </Modal.Body>
                    </Modal>
                </div>
            }
        </div>
    );
}
export default GastoMaterial;
